import { render, staticRenderFns } from "./TrackSamplingReport.vue?vue&type=template&id=6a80bcae&scoped=true"
import script from "./TrackSamplingReport.vue?vue&type=script&lang=js"
export * from "./TrackSamplingReport.vue?vue&type=script&lang=js"
import style0 from "./TrackSamplingReport.vue?vue&type=style&index=0&id=6a80bcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80bcae",
  null
  
)

export default component.exports